export default __webpack_public_path__ + "static/media/undraw_error.ad5a3581.svg";